import { createTheme } from '@mui/material/styles';

// *** ÄNDERUNG ***
// Wir definieren ALLE @font-face Regeln hier.
const globalFontFaces = `
  /* --- Supermolot (für Überschriften) --- */
  @font-face {
    font-family: 'Supermolot';
    /* Der Pfad zeigt jetzt auf deinen public-Ordner.
      Ich habe nur .woff genommen, wie in deinem Screenshot.
      Falls du auch .woff2 hast, füge es als erste 'src' hinzu:
      src: url('/fonts/Supermolot-BlackItalic.woff2') format('woff2'),
           url('/fonts/Supermolot-BlackItalic.woff') format('woff');
    */
    src: url('/fonts/Supermolot-BlackItalic.woff') format('woff');
    font-weight: 900;
    font-style: italic;
    font-display: swap;
  }

  /* --- Open Sans (Standard-Text) --- */
  @font-face {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 100 900; /* Definiert den vollen Bereich der variablen Schriftart */
    font-display: swap;
    /* 'truetype-variations' ist wichtig für variable Fonts.
      Der Pfad /fonts/... verweist auf public/fonts/...
    */
    src: url('/fonts/OpenSans-VariableFont_wdth,wght.ttf') format('truetype-variations');
  }

  /* --- Open Sans (Kursiv-Text) --- */
  @font-face {
    font-family: 'Open Sans';
    font-style: italic;
    font-weight: 100 900;
    font-display: swap;
    src: url('/fonts/OpenSans-Italic-VariableFont_wdth,wght.ttf') format('truetype-variations');
  }
`;

// Die Auto-Animation (bleibt unverändert)
const carAnimations = `
  @keyframes raceAcross {
    from {
      left: 100%; 
    }
    to {
      left: -150px;
    }
  }
`;

export const carreraTheme = createTheme({
    palette: {
        primary: { main: 'rgb(224, 0, 0)' },
        secondary: { main: 'rgb(30, 45, 125)' },
        text: { primary: 'rgb(0, 0, 0)' },
        background: { default: '#f7f8fd', paper: 'rgb(255, 255, 255)' },
        error: { main: 'rgb(224, 0, 0)' },
    },
    typography: {
        // *** ÄNDERUNG ***
        // 'Open Sans' wird die neue Standardschrift für alle normalen Texte (wie <p>)
        fontFamily: "'Open Sans', Helvetica, Arial, sans-serif",

        // Diese bleiben gleich, da sie 'Supermolot' korrekt verwenden
        h1: { fontFamily: "'Supermolot', Arial, sans-serif", fontWeight: 900, fontStyle: 'italic', textTransform: 'uppercase' },
        h2: { fontFamily: "'Supermolot', Arial, sans-serif", fontWeight: 900, fontStyle: 'italic', textTransform: 'uppercase' },
        h3: { fontFamily: "'Supermolot', Arial, sans-serif", fontWeight: 900, fontStyle: 'italic', textTransform: 'uppercase' },
        h4: { fontFamily: "'Supermolot', Arial, sans-serif", fontWeight: 900, fontStyle: 'italic', textTransform: 'uppercase' },
        h5: { fontFamily: "'Supermolot', Arial, sans-serif", fontWeight: 900, fontStyle: 'italic', textTransform: 'uppercase' },
        h6: { fontFamily: "'Supermolot', Arial, sans-serif", fontWeight: 900, fontStyle: 'italic' },

            // *** ÄNDERUNG ***
            // Definiert die Schriftart für Buttons explizit,
            // damit sie auch 'Open Sans' verwenden.
            button: {
                fontFamily: "'Open Sans', Helvetica, Arial, sans-serif",
                fontWeight: 700, // Beispiel: Buttons sollen fett sein
                textTransform: 'none' // MUI macht Buttons oft groß, dies macht sie normal
            },
        },
        components: {
            MuiCssBaseline: {
                styleOverrides: globalFontFaces + carAnimations, // *** ÄNDERUNG ***
            },
            MuiButton: {
                styleOverrides: {
                    root: { height: '52px', padding: '10px 24px' },
                },
            },
            MuiTextField: {
                styleOverrides: {
                    root: { '& .MuiOutlinedInput-root': {} }
                }
            }
        },
    });